(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-sticky-atc"] && !Shopify.designMode) return;
  try {
    (function () {
    const bar = document.getElementById('custom-sticky-atc');
    if (!bar) return;

    const productId = bar.dataset.productId;

    // ── Elementos del bar ──────────────────────────────────────────────────────
    const satcImg     = bar.querySelector('#satc-img');
    const satcVariant = bar.querySelector('#satc-variant');
    const satcPrice   = bar.querySelector('#satc-price');
    const satcCompare = bar.querySelector('#satc-compare');
    const satcBtn     = bar.querySelector('#satc-btn');
    const atcText     = satcBtn.dataset.atcText;
    const soldOutText = satcBtn.dataset.soldOutText;
    const unavailableText = satcBtn.dataset.unavailableText;

    // ── IntersectionObserver: mostrar/ocultar el bar ───────────────────────────
    const originalBtn = document.querySelector('[ref="addToCartButton"]');

    if (originalBtn) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const visible = !entry.isIntersecting;
            bar.classList.toggle('satc--visible', visible);
            bar.setAttribute('aria-hidden', String(!visible));
          });
        },
        { threshold: 0, rootMargin: '0px' }
      );
      observer.observe(originalBtn);
    }

    // ── Click en el botón sticky → dispara el form original ───────────────────
    satcBtn.addEventListener('click', () => {
      const btn = document.querySelector('[ref="addToCartButton"]');
      if (btn && !btn.disabled) btn.click();
    });

    // ── Sync con variant:update ────────────────────────────────────────────────
    // El evento 'variant:update' se dispara en la section del producto (main) y
    // burbujea hasta document. El sticky vive en el HEADER section, por eso colgar
    // el listener de "su" section no recibía el evento (handler nunca corría).
    // Escuchamos en document; el guard de productId de abajo filtra el producto.
    document.addEventListener('variant:update', (event) => {
      const { resource, data } = event.detail;

      if (data.productId && data.productId !== productId) return;

      // Imagen de variante
      if (resource?.featured_media?.preview_image?.src) {
        if (satcImg instanceof HTMLImageElement) {
          satcImg.src = resource.featured_media.preview_image.src + '&width=100';
        }
      }

      // Variante seleccionada (título)
      if (resource?.title && resource.title !== 'Default Title') {
        satcVariant.textContent = resource.title.replace(' / ', ' | ');
      } else {
        satcVariant.textContent = '';
      }

      // Precio: fuente de verdad ESTABLE = mapa variantId -> discount_percent
      // (window.__stanleySatcDiscounts, generado por Liquid una sola vez).
      // No usamos data.html ni el DOM: el primer variant:update no trae el
      // product-price principal y theme.liquid pisa los data-*. El id de la
      // variante del evento siempre es correcto. Determinístico, sin timing.
      const satcMap = window.__stanleySatcDiscounts || {};
      const satcResource = resource || {};
      const satcPct = parseInt(satcMap[satcResource.id], 10) || 0;
      const satcRaw = satcResource.price || 0;
      const satcCompareAt = satcResource.compare_at_price || 0;
      const satcFmt = window.stanleyFormatMoney || function (cents) {
        return '$' + Math.round(cents / 100).toLocaleString('es-AR');
      };
      let satcOnSale = false;

      if (satcPct > 0 && satcRaw > 0) {
        // Descuento por metafield: precio = descontado, tachado = precio de lista
        satcPrice.textContent = satcFmt(Math.round(satcRaw * (100 - satcPct) / 100));
        satcCompare.textContent = satcFmt(satcRaw);
        satcCompare.style.display = '';
        satcOnSale = true;
      } else if (satcCompareAt > satcRaw && satcRaw > 0) {
        // Descuento por compare_at_price nativo
        satcPrice.textContent = satcFmt(satcRaw);
        satcCompare.textContent = satcFmt(satcCompareAt);
        satcCompare.style.display = '';
        satcOnSale = true;
      } else {
        // Sin descuento
        if (satcRaw > 0) satcPrice.textContent = satcFmt(satcRaw);
        satcCompare.textContent = '';
        satcCompare.style.display = 'none';
      }

      satcPrice.classList.toggle('satc__price--sale', satcOnSale);

      // Estado del botón
      // STANLEY FIX: bloquear también cuando la variante nueva tiene precio
      // $0 — "Agotado" tiene prioridad de mensaje sobre "No disponible" si
      // por algún motivo se dan ambos casos a la vez.
      if (resource?.available === false) {
        satcBtn.disabled = true;
        satcBtn.textContent = soldOutText;
      } else if (typeof satcRaw === 'number' && satcRaw <= 0) {
        satcBtn.disabled = true;
        satcBtn.textContent = unavailableText;
      } else {
        satcBtn.disabled = false;
        satcBtn.textContent = atcText;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["custom-variant-swatches"] && !Shopify.designMode) return;
  try {
    (function () {

    function initSwatches(wrapper) {
      if (wrapper._swatchesInit) return;
      wrapper._swatchesInit = true;

      var track = wrapper.querySelector('.card-swatches__track');
      var prevBtn = wrapper.querySelector('.card-swatches__nav--prev');
      var nextBtn = wrapper.querySelector('.card-swatches__nav--next');

      if (!track) return;

      var SCROLL_AMOUNT = 108;

      function updateNav() {
        if (!prevBtn || !nextBtn) return;
        prevBtn.hidden = track.scrollLeft <= 2;
        nextBtn.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          track.scrollLeft -= SCROLL_AMOUNT;
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          track.scrollLeft += SCROLL_AMOUNT;
        });
      }

      track.addEventListener('scroll', updateNav, { passive: true });
      updateNav();

      // ── SELECTED STATE FIX ──────────────────────────────────────────────────
      // El on:click del tema solo llama a previewVariant() en el slideshow, pero
      // no actualiza el estado visual --selected ni persiste la variante elegida.
      // Este handler lo resuelve completamente.
      track.addEventListener('click', function (e) {
        var btn = e.target.closest('.card-swatches__swatch');
        if (!btn) return;

        // 1. Actualizar clase --selected en todos los swatches del track
        track.querySelectorAll('.card-swatches__swatch').forEach(function (s) {
          s.classList.remove('card-swatches__swatch--selected');
        });
        btn.classList.add('card-swatches__swatch--selected');

        // 2. Persistir mediaId y variantId en el wrapper para que
        //    ProductCard.#resetVariant() pueda recuperar la selección
        //    cuando el mouse abandona la card (evita volver al primer color).
        wrapper._selectedMediaId = btn.dataset.mediaId || null;
        wrapper._selectedVariantId = btn.dataset.variantId || null;

        // 3. Actualizar el input hidden id (variante correcta para add-to-cart)
        var card = btn.closest('product-card');
        if (!card) return;

        var variantInput = card.querySelector('input[name="id"]');
        if (variantInput && btn.dataset.variantId) {
          variantInput.value = btn.dataset.variantId;
        }

        // 4. Actualizar el href del link de la card con ?variant=ID
        //    para que al hacer click en la card llegue a la variante correcta.
        var link = card.querySelector('a.product-card__link');
        if (link && btn.dataset.variantId) {
          try {
            var url = new URL(link.href);
            url.searchParams.set('variant', btn.dataset.variantId);
            link.href = url.toString();
          } catch (err) {}
        }

        // 5. STANLEY CUSTOM: actualizar precio tachado según metafield discount_percent
        if (typeof window.__stanleyUpdateCardPrice === 'function') {
          window.__stanleyUpdateCardPrice(card, btn.dataset.variantId);
        }
      });
      // ────────────────────────────────────────────────────────────────────────
    }

    function initAll() {
      document.querySelectorAll('.card-swatches__track-wrapper').forEach(initSwatches);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            node.querySelectorAll && node.querySelectorAll('.card-swatches__track-wrapper').forEach(initSwatches);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  })();

// STANLEY: este bloque estaba en un <script> inline al final del snippet y se repetía
// una vez por cada tarjeta (27 veces en la home, ~120 KB de HTML). Acá se compila una sola vez.
(function() {
  function formatMoneyAR(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-AR');
  }

  // STANLEY: actualiza el bloque de cuotas (installments-price) de la card segun
  // el precio de la variante. Si la variante tiene descuento por metafield, calcula
  // la cuota sobre el precio con descuento; si no, sobre el precio lleno.
  // Replica la matematica de installments-price.liquid (division entera).
  function stanleyUpdateCardInstallments(card, discountPct, priceCents) {
    var inst = card.querySelector('.installments-price');
    if (!inst) return;
    var valEl = inst.querySelector('.installments-price__value');
    if (!valEl) return;

    // Conteo de cuotas: preferir data-installments; fallback parseando el texto.
    var count = parseInt(inst.dataset.installments || '', 10);
    if (!count || count < 1) {
      var m = (inst.textContent || '').match(/(\d+)\s+cuota/i);
      count = m ? parseInt(m[1], 10) : 6;
    }
    if (!priceCents || priceCents < 1) return;

    var baseCents = (discountPct > 0)
      ? Math.round(priceCents * (100 - discountPct) / 100)
      : priceCents;
    var perCuota = Math.floor(baseCents / count);
    valEl.textContent = formatMoneyAR(perCuota);
  }

  function stanleyUpdateCardPrice(card, variantId) {
    var swatch      = card.querySelector('.card-swatches__swatch[data-variant-id="' + variantId + '"]');
    var discountPct = swatch ? parseInt(swatch.dataset.discountPercent || '0', 10) : 0;
    var priceCents  = swatch ? parseInt(swatch.dataset.variantPrice   || '0', 10) : 0;

    // STANLEY: recalcular el precio en cuotas segun la variante seleccionada.
    // Se corre antes del early-return de priceContainers para que siempre actualice.
    stanleyUpdateCardInstallments(card, discountPct, priceCents);

    // La tarjeta puede tener MÚLTIPLES priceContainers (desktop + mobile carousel)
    // Hay que actualizar TODOS
    var priceContainers = card.querySelectorAll('[ref="priceContainer"]');
    if (!priceContainers.length) return;

    var imgBadge = card.querySelector('.stanley-card-discount-badge');

    priceContainers.forEach(function(priceContainer) {
      // Limpiar todo lo previo (Liquid + JS)
      priceContainer.querySelectorAll('.stanley-discounted-price, .stanley-discount-badge').forEach(function(el) { el.remove(); });

      // Restaurar precio original
      var origSpan = priceContainer.querySelector('.price');
      if (origSpan) {
        origSpan.style.removeProperty('text-decoration');
        origSpan.style.removeProperty('color');
        origSpan.style.removeProperty('font-size');
        // STANLEY FIX: recalcular el texto (no solo el estilo) con el precio real
        // de la variante activa — antes quedaba stale con el precio de la variante
        // con la que cargó la página, mostrando el número equivocado si la nueva
        // variante costaba distinto.
        if (priceCents > 0) {
          origSpan.textContent = formatMoneyAR(priceCents);
        }
      }

      if (discountPct > 0 && priceCents > 0 && origSpan) {
        var discountedCents = Math.round(priceCents * (1 - discountPct / 100));

        origSpan.style.setProperty('text-decoration', 'line-through');
        origSpan.style.setProperty('color', 'rgba(0,0,0,0.4)');
        origSpan.style.setProperty('font-size', '0.85em');

        var discEl = document.createElement('span');
        discEl.className = 'price stanley-discounted-price';
        discEl.textContent = formatMoneyAR(discountedCents);
        discEl.style.cssText = 'font-weight:500; margin-left:6px;';
        priceContainer.appendChild(discEl);
      }
    });

    // Badge sobre imagen: el <div class="stanley-card-discount-badge"> SIEMPRE
    // existe en el DOM (renderizado por custom-product-card-badges.liquid, oculto
    // con [hidden] cuando no aplica). Acá solo se activan/desactivan clases y el
    // atributo hidden — NUNCA se crea ni se inserta un nodo nuevo en .card-gallery
    // (eso fue lo que rompía la navegación del carrusel al volver a la variante
    // destacada tras pasar por una con descuento).
    if (discountPct > 0 && priceCents > 0) {
      if (imgBadge) {
        imgBadge.classList.add('product-badges__badge', 'product-badges__badge--sale');
        imgBadge.removeAttribute('hidden');
        imgBadge.textContent = '-' + discountPct + '%';
      }
    } else if (imgBadge) {
      imgBadge.classList.remove('product-badges__badge', 'product-badges__badge--sale');
      imgBadge.setAttribute('hidden', '');
    }
  }

  window.__stanleyUpdateCardPrice = stanleyUpdateCardPrice;
})();
  } catch(e) { console.error(e); }
})();

})();
